export const heroSlides = [
  {
    id: 1,
    image: "https://static.wixstatic.com/media/17b604_4cd3a1e73b624ff5ac0b83b7e4c1e84c~mv2.png/v1/fill/w_1280,h_760,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/17b604_4cd3a1e73b624ff5ac0b83b7e4c1e84c~mv2.png",
    title: "지구를 푸르게, 이웃을 따뜻하게.",
    subtitle: "우리의 작은 실천이 세상을 바꿉니다",
  },
];

export const introText = {
  lines: [
    "우리가 사는 인천, 우리가 아름답게",
    "한마음 봉사단은 환경정화 · 나눔봉사 · 재능기부로",
    "따뜻한 지역사회를 만들어갑니다.",
  ],
};

export const activities = [
  {
    id: 1,
    image: "https://static.readdy.ai/image/309c8cd033c69b13958f82260e1bf6fe/669a66cbe9db59b77653f32ceb296319.png",
    title: "우리동네문화바캉스",
  },
  {
    id: 2,
    image: "https://static.wixstatic.com/media/17b604_16f81f9063b84f929ee8c5bc9c6c9ef4~mv2.jpg/v1/fill/w_540,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/17b604_16f81f9063b84f929ee8c5bc9c6c9ef4~mv2.jpg",
    title: "소래찬 김장 한마당",
  },
  {
    id: 3,
    image: "https://static.readdy.ai/image/309c8cd033c69b13958f82260e1bf6fe/eabece572c8ebb498d22b3ab877d04e3.png",
    title: "문화놀이터",
  },
  {
    id: 4,
    image: "https://static.wixstatic.com/media/17b604_f796f7b21aef492f87057a6de620a430~mv2.jpg/v1/fill/w_540,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/17b604_f796f7b21aef492f87057a6de620a430~mv2.jpg",
    title: "일회용품 줄이기 환경정화 운동\n- 인천 대공원 연합 봉사 -",
  },
];

export const ctaSections = [
  {
    id: "donate",
    labelEn: "Donate",
    labelKo: "기부하기",
    description: "한마음으로 만드는 따뜻한 세상\n여러분의 후원은 깨끗한 지역사회와 도움이 필요한 이웃을 위한\n소중한 밑거름이 됩니다.",
    buttonText: "Donate",
    href: "/donate",
  },
  {
    id: "volunteer",
    labelEn: "Volunteer",
    labelKo: "자원 봉사자 모집",
    description: "우리가 사는 인천, 우리가 아름답게.\n한마음 봉사단과 함께 깨끗한 환경과 따뜻한 이웃사랑을 실천할\n자원봉사자를 모집합니다.",
    buttonText: "Volunteer",
    href: "/volunteer",
  },
];

export const newsPosts = [
  {
    id: "ac5a3296-8da2-4d92-a95e-6c957ef6f664",
    image: "https://static.wixstatic.com/media/17b604_a677eb386ca74343b4fc55c0f69678e2~mv2.png/v1/fill/w_292,h_292,fp_0.50_0.50,q_95,enc_avif,quality_auto/17b604_a677eb386ca74343b4fc55c0f69678e2~mv2.png",
    title: "노숙인을 위한 김장 담그기 자원봉사 행사",
    author: "현주 김",
    date: "6월 15일",
    readTime: "3분 분량",
    href: "/post/노숙인을-위한-김장-담그기-자원봉사-행사",
  },
  {
    id: "e5f2398f-3410-47f5-b6f7-d8d9815f1298",
    image: "https://static.wixstatic.com/media/17b604_e7877b92f5f34dccb10e2241b1ee00ea~mv2.png/v1/fill/w_292,h_292,fp_0.50_0.50,q_95,enc_avif,quality_auto/17b604_e7877b92f5f34dccb10e2241b1ee00ea~mv2.png",
    title: "플라스틱 줄이기와 다회용 컵 사용 촉진",
    author: "현주 김",
    date: "6월 15일",
    readTime: "2분 분량",
    href: "/post/플라스틱-줄이기와-다회용-컵-사용-촉진",
  },
  {
    id: "cd8ae7e1-eb55-4242-a74e-0e806fa817bf",
    image: "https://static.wixstatic.com/media/17b604_c7c65af9dfaf4b30b0169e0e4169e8e0~mv2.png/v1/fill/w_292,h_292,fp_0.50_0.50,q_95,enc_avif,quality_auto/17b604_c7c65af9dfaf4b30b0169e0e4169e8e0~mv2.png",
    title: "환경 정화로 지구를 구하는 한마음 자원봉사단",
    author: "현주 김",
    date: "6월 15일",
    readTime: "2분 분량",
    href: "/post/환경-정화로-지구를-구하는-한마음-자원봉사단",
  },
];

export const footerData = {
  brand: "한마음 봉사단",
  phone: "032-468-5505",
  address: ["인천시 남동구 구월말로 111", "1층"],
  socialLinks: [
    { label: "facebook", href: "https://www.facebook.com/wix" },
    { label: "twitter", href: "https://www.twitter.com/Wix" },
    { label: "youtube", href: "https://www.youtube.com/user/Wix" },
    { label: "instagram", href: "https://www.instagram.com/wix" },
  ],
  legalLinks: [
    { label: "Terms & Conditions", href: "/terms-and-conditions" },
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Accessibility Statement", href: "/accessibility-statement" },
  ],
  copyright: "© 2035 by Helping Hands. Powered and secured by Readdy",
};